const getDuplicateCardMessage = (last4) =>
  `${last4 ? `The card ending in ${last4}` : 'This card'} is already added above. Please enter a different card, or remove this one and assign its items to the existing card.`;

export default getDuplicateCardMessage;
